import { Injectable, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { of } from "rxjs";
import { VIEWER_SERVICE } from "../../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";

/**
 * Exposes the viewer's developer-tools flag as a reactive signal.
 * Source of truth: BaseViewerService.developerTools$ (toggled via Alt+0 in the viewer toolbar).
 * When used outside a viewer context (no VIEWER_SERVICE provider), defaults to false.
 */
@Injectable()
export class DebugModeService {
  readonly #viewerService = inject(VIEWER_SERVICE, { optional: true });

  readonly isDebugMode = toSignal(this.#viewerService?.developerTools$ ?? of(false), { initialValue: false });
}
